// extracted by mini-css-extract-plugin
module.exports = {"content":"RemarksModal_content__LHf0V","dialog":"RemarksModal_dialog__3tbwH","body":"RemarksModal_body__16ZCz"};